<template>
  <div class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="headerWrap">EDIT MULTIMESSAGE</h2>
        <div class="closeMessageModalWrapper">
          <close-icon
            @closeEvent="$emit('closeEditing')"
            :dark="true"
          ></close-icon>
        </div>
      </div>
      <div class="modal-body">
        <div class="MultiMessageType">
          <div class="sendEmailSmsWrapper">
            <label for="messageName" class="labelBold">NAME</label>
            <input
              type="text"
              class="messageName"
              name="messageName"
              placeholder="Message's name"
              v-model="messageName"
            />
          </div>
          <div class="sendEmailSmsWrapper">
            <label for="messageSelection" class="labelBold">SELECTION</label>
            <select
              name="messageSelection"
              class="emailSmsMessage"
              v-model="guestSelection"
              v-if="!$isSingleLanguage"
            >
              <option
                v-for="selectionType in messageSelectiontypes"
                :key="selectionType.name"
                :value="selectionType.name"
              >
                {{ selectionType.name }}
              </option>
            </select>
            <select
              name="messageSelection"
              class="emailSmsMessage"
              v-model="guestSelection"
              v-else
            >
              <option
                v-for="selectionType in messageSelectiontypes.slice(0, 2)"
                :key="selectionType.name"
                :value="selectionType.name"
              >
                {{ selectionType.name }}
              </option>
            </select>
          </div>
          <div class="sendEmailSmsWrapper" v-if="emailService || smsService">
            <label for="emailSmsMessage" class="labelBold">TYPE</label>
            <select
              name="emailSmsMessage"
              class="emailSmsMessage"
              v-model="messageType"
            >
              <option value="E-MAIL" v-if="emailService">E-MAIL</option>
              <option value="SMS" v-if="smsService">SMS</option>
            </select>
          </div>
        </div>
        <div class="MultiMessageTemplate">
          <div class="smsWrapper extendHeight" v-if="messageType === 'SMS'">
            <div class="labelWrap">
              <p>TEMPLATE</p>
            </div>
            <textarea
              type="text"
              v-model="smsMessage"
              placeholder="Type your message here."
            />
          </div>
          <div class="sendEmailSmsWrapper" v-if="messageType === 'SMS'">
            <div class="labelWrap">
              <p>SMS INFORMATION:</p>
            </div>
            <div class="charInformation">
              <p>Characters: {{ messageLength }}</p>
              <p>Messages: {{ Math.ceil(messageLength / 160) }}</p>
            </div>
          </div>
          <div class="sendEmailSmsWrapper" v-if="messageType === 'E-MAIL'">
            <label for="subjectInput" class="labelBold">SUBJECT</label>
            <div class="subjectInput">
              <input
                class="form-control"
                name="subjectInput"
                v-model="emailSubject"
                placeholder="Type your subject here."
              />
            </div>
          </div>
          <div
            class="emailWrapper extendHeight"
            v-if="messageType === 'E-MAIL'"
          >
            <label for="tinyEditor" class="labelBold">TEMPLATE</label>
            <div class="tinyEditor">
              <HtmlEditor
                v-if="editorActive"
                v-model="emailMessage"
                api-key="o8eqr3asmep3tnky3mpofyp8062atqx826sxagxm6xq3a7c2"
                :init="{
                  selector: 'imgTest',
                  plugins: 'wordcount',
                  plugins: 'link lists hr code table',
                  branding: false,
                  menubar: false,
                  toolbar:
                    'formatselect forecolor bold italic fontsizeselect | bullist numlist alignleft aligncenter alignright alignjustify link hr removeformat code table imgBtn',
                  fontsize_formats: '8pt 11pt 10pt 12pt 14pt 18pt 24pt 36pt',
                  height: '250px',
                  resize: true,
                  setup: function (editor) {
                    editor.ui.registry.addButton('imgBtn', {
                      text: 'Image',
                      onAction: function () {
                        hideToolbar();
                        showImageModal = true;
                      },
                    });
                  },
                }"
              ></HtmlEditor>
              <ImageManager
                v-if="showImageModal"
                :isModal="true"
                @changed="onSelectedImage"
                @close="(showImageModal = false), showToolbar()"
              />
            </div>
          </div>
        </div>
        <div class="MultiMessageScheduler">
          <div class="sendEmailSmsWrapper">
            <label for="MultiMessageScheduler" class="labelBold"
              >SENDING AT</label
            >
            <datepicker
              v-model="schedulerSendingDate"
              wrapper-class="datePickerOuterWrap"
              input-class="datePickerInput"
              calendar-class="dateCalendar"
              placeholder="Select a Day"
              :disabledDates="disabledDates"
              name="MultiMessageScheduler"
            ></datepicker>
          </div>
          <div
            class="sendEmailSmsWrapper"
            v-if="messageFrequency !== 'One Time'"
          >
            <label for="MultiMessageScheduler" class="labelBold"
              >ENDING AT</label
            >
            <datepicker
              v-model="schedulerEndDate"
              wrapper-class="datePickerOuterWrap"
              input-class="datePickerInput"
              calendar-class="dateCalendar"
              placeholder="Select a Day"
              :disabledDates="disabledDates"
              name="MultiMessageScheduler"
            ></datepicker>
          </div>
          <div class="sendEmailSmsWrapper">
            <label for="MultiMessageScheduler" class="labelBold">HOUR</label>
            <select
              name="scheduledHour"
              id="scheduledHour"
              v-model="scheduledHour"
            >
              <option :value="hour" v-for="hour in hourArray" :key="hour">
                {{ hour }}
              </option>
            </select>
          </div>
          <div class="sendEmailSmsWrapper">
            <label for="messageFrequency" class="labelBold">FREQUENCY</label>
            <select name="messageFrequency" v-model="messageFrequency">
              <option
                :value="singleFreq"
                v-for="singleFreq in frequencyArray"
                :key="singleFreq"
              >
                {{ singleFreq }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="ActionButtonWrap">
        <button-global
          type="negative"
          text="CANCEL"
          @eventPassed="$emit('closeEditing')"
        ></button-global>
        <button-global
          type="positive"
          text="SAVE"
          @eventPassed="showApproveModal = true"
        ></button-global>
      </div>
      <fetching-loader
        displayType="displayFixed"
        v-if="updatingMessage"
      ></fetching-loader>
      <transition name="fadeInModal">
        <approve-modal
          @yes="saveEditing"
          @no="showApproveModal = false"
          v-if="showApproveModal"
        >
          <p slot="text">Are you sure you want to update this message?</p>
        </approve-modal>
      </transition>
    </div>
  </div>
</template>

<script>
import CloseIcon from "@/components/GlobalComponents/CloseIcon";
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";
import ApproveModal from "@/components/GlobalComponents/ApproveModal";
import ImageManager from "@/components/MediaPage/MediaImages";
import Datepicker from "vuejs-datepicker";
import HtmlEditor from "@/components/GlobalComponents/HtmlEditor";
import returnUTCTimeMixin from "@/mixins/returnUTCTimeMixin";
import convertToUTCMixin from "@/mixins/convertToUTCMixin";
import { firestore } from "@/firebase";
import bus from "@/bus.js";

export default {
  name: "EditMultiMessageScheduler",
  components: {
    CloseIcon,
    ButtonGlobal,
    FetchingLoader,
    ApproveModal,
    ImageManager,
    Datepicker,
    HtmlEditor,
  },
  mixins: [returnUTCTimeMixin, convertToUTCMixin],
  props: {
    selectedMessageObject: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      updatingMessage: false,
      schedulerSendingDate: new Date(this.selectedMessageObject.sendingAt),
      schedulerEndDate: new Date(this.selectedMessageObject.endingAt),
      disabledDates: {
        customPredictor: function (date) {
          var newDateFromObject = new Date().setDate(new Date().getUTCDate());
          if (newDateFromObject > date) {
            return true;
          }
        },
      },
      hourArray: [
        "00:00",
        "01:00 a.m",
        "02:00 a.m",
        "03:00 a.m",
        "04:00 a.m",
        "05:00 a.m",
        "06:00 a.m",
        "07:00 a.m",
        "08:00 a.m",
        "09:00 a.m",
        "10:00 a.m",
        "11:00 a.m.",
        "12:00 p.m",
        "13:00 p.m.",
        "14:00 p.m",
        "15:00 p.m",
        "16:00 p.m",
        "17:00 p.m",
        "18:00 p.m",
        "19:00 p.m",
        "20:00 p.m",
        "21:00 p.m",
        "22:00 p.m",
        "23:00 p.m",
      ],
      scheduledHour: this.selectedMessageObject.scheduledHour,
      frequencyArray: ["One Time", "Daily", "Weekly"],
      messageFrequency: this.selectedMessageObject.messageFrequency,
      showImageModal: false,
      showApproveModal: false,
      showArchive: false,
      editorActive: true,
      smsService: true,
      emailService: true,
      smsMessage: this.selectedMessageObject.messageContent,
      emailSubject: this.selectedMessageObject.subjectContent
        ? this.selectedMessageObject.subjectContent
        : "",
      emailMessage: this.selectedMessageObject.messageContent,
      messageType: this.selectedMessageObject.messageType,
      guestSelection: this.selectedMessageObject.selectionType,
      messageName: this.selectedMessageObject.messageName,
      messageSelectiontypes: [
        {
          name: "MANUAL SELECTION",
        },
        {
          name: "SELECT ALL GUESTS",
        },
        {
          name: "SELECT NATIVE GUESTS",
        },
        {
          name: "SELECT FOREIGN GUESTS",
        },
      ],
    };
  },
  created() {
  },
  deactivated() {
    this.editorActive = false;
  },
  activated() {
    this.editorActive = true;
  },
  computed: {
    messageLength() {
      var messageCount = this.smsMessage.length;
      if (this.smsMessage.match(/##hotel##/g)) {
        messageCount = messageCount + this.$customerId.length - 9;
      }
      if (this.smsMessage.match(/##roomnumber##/g)) {
        messageCount = messageCount + 3 - 14;
      }
      if (this.smsMessage.match(/##link##/g)) {
        messageCount = messageCount + 56 + this.$hotelId.length - 8;
      }
      return messageCount;
    },
    correctMessageContent() {
      return this.messageType === "E-MAIL"
        ? this.emailMessage
        : this.smsMessage;
    },
  },
  methods: {
    saveEditing() {
      this.showApproveModal = false;
      this.updatingMessage = true;
      const utcTimeStampConverted = this.returnUTCTime();
      const formatedDate = new Date(utcTimeStampConverted).toISOString();

      firestore
        .collection("MultimessageScheduler")
        .doc(`${this.$hotelId}`)
        .collection("ScheduledMessages")
        .doc(`${this.selectedMessageObject.documentID}`)
        .update({
          createdAt: formatedDate,
          sendingAt: this.convertToUTC(this.schedulerSendingDate),
          endingAt: this.convertToUTC(this.schedulerEndDate),
          messageType: this.messageType,
          messageName: this.messageName,
          selectionType: this.guestSelection,
          messageFrequency: this.messageFrequency,
          scheduledHour: this.scheduledHour,
          messageContent: this.correctMessageContent,
          subjectContent: this.messageType === "SMS" ? null : this.emailSubject,
        })
        .then(() => {
          this.updatingMessage = false;
          this.$emit("closeEditing");
          bus.$emit("rerenderComp");
          this.$toastEvents.push({
            type: "positive",
            title: "Success",
            content: "Message has been updated",
            id: +new Date(),
          });
        });
    },
    onSelectedImage(imageUrl) {
      this.emailMessage += `<p><img class="responsive" style="display: block; margin-left: auto; margin-right: auto;" src="${imageUrl}" alt="second img"  /></p>`;
    },
    hideToolbar() {
      document.querySelector(".tox-toolbar__overflow").style.display = "none";
    },
    showToolbar() {
      document.querySelector(".tox-toolbar__overflow").style.display = "block";
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h1,
h2,
h3,
h4,
p,
label {
  color: #707070;
  font-size: 16px;
}
h2.headerWrap {
  margin-top: 10px;
  margin-bottom: 40px;
  font-size: 32px;
  font-weight: 100;
}
label {
  margin: 10px 0;
}
.labelBold {
  font-weight: bold;
}
.modal {
  position: fixed;
  z-index: 910;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}
.closeMessageModalWrapper {
  position: absolute;
  top: 0px;
  right: 5px;
}
/* Modal Content */
.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 4px;
  background-color: #fefefe;
  margin: auto;
  margin-top: 30px;
  padding: 20px 60px;
  width: 90%;
  height: 90%;
  border: 1px solid #707070;
  border-radius: 15px;
}
.modal-body {
  display: flex;
  justify-content: space-around;
}

.ActionButtonWrap {
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.MultiMessageTemplate {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin: 0 50px;
}
.datePickerOuterWrap {
  height: 45px;
}
.dateWrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex-grow: 1;
  margin-top: 15px;
}
select {
  border: 1px solid #707070;
  width: 200px;
  height: 50px;
  padding: 10px 5px;
  border-radius: 5px;
}
input {
  border: 1px solid #707070;
  width: 200px;
  padding: 10px;
  border-radius: 5px;
}

.sendEmailSmsWrapper,
.smsWrapper {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.emailWrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.labelWrap {
  margin-bottom: 15px;
}
.rightColumn {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.charInformation {
  display: flex;
}
.charInformation > p:nth-child(1) {
  margin-right: 15px;
}

.messagesInformatioNWrapper {
  margin-top: 40px;
  justify-content: center;
}
.smsCharInfoWrapper p {
  margin: 0;
}
.emailSmsMessage {
  width: 250px;
  padding: 8px;
  border: 1px solid #707070;
  border-radius: 5px;
}

.labelWrap p {
  margin: 5px 0;
  font-weight: bold;
}
.subjectInput {
  width: 100%;
}
.form-control,
.messageName {
  padding: 15px 18px;
  width: 100%;
  color: #66615b;
  border: 1px solid #707070;
  border-radius: 4px;
  outline: 0;
  -webkit-transition: 0.3s ease-in;
  transition: 0.3s ease-in;
}
.extendHeight {
  flex-grow: 1;
}
textarea {
  resize: none;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border: 1px solid #707070;
  border-radius: 5px;
  color: #66615b;
  font-size: 16px;
  padding: 18px;
}
.tinyEditor {
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 1025px) {
  h2.headerWrap {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 20px;
  }
  input,
  select,
  .emailSmsMessage,
  .datePickerOuterWrap,
  .messageName {
    width: 130px;
  }
  .ActionButtonWrap {
    margin-top: 10px;
  }
  .modal-content {
    margin-top: 10px;
    height: 95%;
  }
}
@media screen and (max-width: 769px) {
  .modal-content {
    margin-top: 10px;
    padding: 15px;
    width: 95%;
  }
  .MultiMessageTemplate {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin: 0 15px;
  }
  .selectionWrap {
    width: 100%;
    margin-bottom: 30px;
  }
  h2.headerWrap {
    margin-top: 20px;
    margin-bottom: 30px;
    font-size: 24px;
  }
  .ActionButtonWrap {
    margin-top: 0px;
    align-items: center;
  }
}
</style>
